import { removeItem } from "../../Auth/localStorageService";

export const removeUserSignUpInformationFromLocalStorage = () => {
  removeItem("userFormDetails");
  removeItem("insuranceCards");
};
